import React from "react";
import { Container } from "@prestosports/commons-ui";
import AddPlayer from "../components/AddPlayer";

const AddPlayerContainer = ({ team, player, onSave, onCancel }) => {
	return (
		<Container fullHeight noPaper>
			<AddPlayer team={team} player={player} onSave={onSave} onCancel={onCancel} />
		</Container>
	);
};

export default AddPlayerContainer;
